import MaxWidthWrapper from "@aix/ui/src/custom/MaxWidthWrapper"
import { createFileRoute } from "@tanstack/react-router"
import Description from "~/components/Marketing/Description"
import FreeTools from "~/components/Marketing/FreeTools"
import Title from "~/components/Marketing/Title"
import CustomHead from "~/components/SEOHead/CustomHead"
import MarketingLayout from "~/layouts/MarketingLayout"
import { getPageSEO } from "~/utils/seo"

import type { ReactElement } from "react"

function ToolsPage() {
  const toolsSEO = getPageSEO("tools")

  return (
    <>
      <CustomHead
        title={toolsSEO.title}
        description={toolsSEO.description}
        keywords={toolsSEO.keywords}
        pageType={toolsSEO.pageType}
        url="https://vidmax.ai/tools"
      />

      <MaxWidthWrapper className="flex flex-col items-center pt-20">
        {/* <div className="flex items-center gap-2">
          <Link
            to="/"
            className="transition-colors ease-in-out hover:text-primary"
          >
            Home
          </Link>

          <Icon name="chevron-right" size={12} />

          <Link to="/tools" className="font-bold text-primary">
            Tools
          </Link>
        </div> */}

        <Title data-testid="hero-text">Free Tools</Title>

        <Description>Try out our free tools</Description>

        <FreeTools title="" />
      </MaxWidthWrapper>
    </>
  )
}

function ToolsPageWrapper() {
  return (
    <MarketingLayout>
      <ToolsPage />
    </MarketingLayout>
  )
}

export const Route = createFileRoute("/tools/")({
  component: ToolsPageWrapper,
})
